/**
 * Layout - root layout shell shared boi tat ca route.
 *
 * Wraps the app voi LangProvider (Vietnamese / English locale context),
 * Header, Footer, ConsentBanner. Children route mount qua <Outlet/>.
 *
 * Tach tu app.tsx cu de:
 *   1. vite-react-ssg can routes config la RouteRecord[] voi root layout
 *      = element + entry, KHONG phai <BrowserRouter> tree.
 *   2. SSR/SSG context (Helmet/Head) chia se chung 1 provider tree.
 *   3. Layout chinh la "shell" prerender mot lan + reuse khi navigate.
 */

import { Outlet, useLocation } from 'react-router-dom';
import { ConsentBanner } from './components/consent-banner';
import { Footer } from './components/footer';
import { Header } from './components/header';
import { LangProvider } from './use-lang';

export function Layout() {
  // Issue 4 (legal-upl C5): the Footer is route-gated OFF /chat only - /chat is a
  // full-height app surface where the footer would push the fixed composer off
  // screen. The Footer is KEPT for every other route (landing / blog / news /
  // privacy / terms etc.) which legally require it. We do NOT delete it globally.
  const { pathname } = useLocation();
  const isChat = pathname === '/chat' || pathname.startsWith('/chat/');
  // App shell Phase 1 (spec 2026-06-12-telegram-liquid-glass): /chat + /tim-kiem
  // dung NavRail thay Header. /van-ban detail GIU Header den Phase 2.
  const isSearch = pathname === '/tim-kiem' || pathname === '/tim-kiem/';
  const isAppRoute = isChat || isSearch;
  // Editorial Authority landing has its own FooterAnchor - gate global Footer off
  // to avoid double footer. Covers EN `/` + VN `/vi` + `/vi/`.
  const isEditorialLanding = pathname === '/' || pathname === '/vi' || pathname === '/vi/';

  const shellClass = isChat
    ? 'app-shell app-shell--chat'
    : isAppRoute
      ? 'app-shell app-shell--rail'
      : 'app-shell';

  return (
    <LangProvider>
      <div className={shellClass}>
        {!isAppRoute && <Header />}
        <div className="app-main">
          <Outlet />
        </div>
        {!isChat && !isEditorialLanding && <Footer />}
        <ConsentBanner />
      </div>
    </LangProvider>
  );
}
